import { useCallback, useEffect, useRef, useState } from 'react';

const MOBILE_CLOSE_DURATION_MS = 260;
const DESKTOP_CLOSE_DURATION_MS = 260;

function getCloseDuration() {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
		return MOBILE_CLOSE_DURATION_MS;
	}

	return window.matchMedia('(min-width: 600px)').matches
		? DESKTOP_CLOSE_DURATION_MS
		: MOBILE_CLOSE_DURATION_MS;
}

function useAnimatedModalClose(onClose) {
	const [isClosing, setIsClosing] = useState(false);
	const closeTimerRef = useRef(null);
	const pendingActionRef = useRef(null);

	const requestClose = useCallback(nextAction => {
		if (isClosing) {
			return;
		}

		pendingActionRef.current = typeof nextAction === 'function' ? nextAction : null;
		setIsClosing(true);
		closeTimerRef.current = window.setTimeout(() => {
			const action = pendingActionRef.current;
			pendingActionRef.current = null;
			(action || onClose)();
		}, getCloseDuration());
	}, [isClosing, onClose]);

	useEffect(() => {
		return () => {
			if (closeTimerRef.current) {
				window.clearTimeout(closeTimerRef.current);
			}

			pendingActionRef.current = null;
		};
	}, []);

	return { isClosing, requestClose };
}

export default useAnimatedModalClose;